module.exports = __webpack_public_path__ + "static/media/domain-address-registration.f8decc60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/domain-address-registration.svg
// module id = 331
// module chunks = 0